import authService from '../auth/auth-service';
import config from '../../config';

const _configAPITecnico = config.configAPITecnico();

class OmniloraService {

  async cadastrarOmnilora(dados) {
    try {
      const _headerToken = authService.headerAPITecnico();
      const response = await fetch(`${_configAPITecnico.URI_API}/omnilora/cadastrarAssociacaoLora`, {
        method: 'POST',
        headers: _headerToken,
        body: JSON.stringify(dados),
      });

      if (response.ok) {
        return { error: false };
      }

      const errorBody = await response.json().catch(() => null);
      let message = 'Erro ao cadastrar o omnilora.'; 

      if (typeof errorBody === 'string') {
        message = errorBody;
      } else if (errorBody && typeof errorBody.errors === 'object') {
        const errorMessages = Object.values(errorBody.errors).flat();
        if (errorMessages.length > 0) {
          message = errorMessages.join('\n'); 
        }
      } else if (errorBody && errorBody.title) {
        message = errorBody.title;
      }

      return { error: true, message };

    } catch (error) {
      return {
        error: true,
        message: 'Falha na comunicação com o servidor. Verifique sua conexão ou tente novamente mais tarde.'
      };
    }
  }

  async atualizarOmnilora(dados) {
    try {
      const _headerToken = authService.headerAPITecnico();
      const response = await fetch(`${_configAPITecnico.URI_API}/omnilora/atualizarAssociacaoLora`, {
        method: 'PUT',
        headers: _headerToken,
        body: JSON.stringify(dados),
      });

      if (response.ok) {
        return { error: false };
      }

      const errorBody = await response.json().catch(() => null);
      let message = 'Erro ao atualizar o omnilora.'; 

      if (typeof errorBody === 'string') {
        message = errorBody;
      } else if (errorBody && typeof errorBody.errors === 'object') {
        const errorMessages = Object.values(errorBody.errors).flat();
        if (errorMessages.length > 0) {
          message = errorMessages.join('\n'); 
        }
      } else if (errorBody && errorBody.title) {
        message = errorBody.title;
      }

      return { error: true, message };

    } catch (error) {
      return {
        error: true,
        message: 'Falha na comunicação com o servidor. Verifique sua conexão ou tente novamente mais tarde.'
      };
    }
  }

  async buscarOmnilora(IdLora) {
    try {
      const _headerToken = authService.headerAPITecnico();
      const response = await fetch(`${_configAPITecnico.URI_API}/omnilora/listarCadastroAssociacao?IdLora=${IdLora}`, {
        method: 'GET',
        headers: _headerToken,
      });

      const data = await response.json();

      if (response.status === 200) {
        return { error: false, result: data };
      } else {
        return { error: true, message: data || 'Erro ao atualizar o omnilora.' };
      }
    } catch (error) {
      return {
        error: true,
        message: 'Falha na comunicação com o servidor. Verifique sua conexão ou tente novamente mais tarde.'
      };
    }
  }
}

export default new OmniloraService();
